module.exports = __webpack_public_path__ + "static/media/modelo_gestion_circulo.269849c8.png";